import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=c1a717cc"
import script from "./Rewards.vue?vue&type=script&lang=js"
export * from "./Rewards.vue?vue&type=script&lang=js"
import style0 from "./Rewards.vue?vue&type=style&index=0&id=c1a717cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports